import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Verify2FA from "./pages/Verify2FA";
import Patients from "./pages/patients";
import Customers from "./pages/Customers";
import Manufacturers from "./pages/Manufacturers";
import SurgicalMaterials from "./pages/SurgicalMaterials";
import UsersWrapper from "./pages/UsersWrapper";
import NotFound from "./pages/NotFound";
import Reporting from "./pages/Reporting";
import DataImport from "./pages/DataImport";
import DataExport from "./pages/DataExport";
import Datensicherung from "./pages/Datensicherung";
import AdminRoute from "./components/AdminRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import ChangePassword from "./pages/ChangePassword";
import { SessionProvider } from "./contexts/SessionContext";

const queryClient = new QueryClient();

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#E18E33",
    },
    secondary: {
      main: "#F1F1F1",
    },
    text: {
      primary: "#2D2D2D",
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <SessionProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-2fa" element={<Verify2FA />} />
          <Route path="/patients" element={<ProtectedRoute><Patients /></ProtectedRoute>} />
          <Route path="/data-export" element={<ProtectedRoute><DataExport /></ProtectedRoute>} />
          {/* Admin-only routes */}
          <Route path="/customers" element={<AdminRoute><Customers /></AdminRoute>} />
          <Route path="/manufacturers" element={<AdminRoute><Manufacturers /></AdminRoute>} />
          <Route path="/surgical-materials" element={<AdminRoute><SurgicalMaterials /></AdminRoute>} />
          <Route path="/users" element={<AdminRoute><UsersWrapper /></AdminRoute>} />
          <Route path="/reporting" element={<AdminRoute><Reporting /></AdminRoute>} />
          <Route path="/data-import" element={<AdminRoute><DataImport /></AdminRoute>} />
          <Route path="/datensicherung" element={<AdminRoute><Datensicherung /></AdminRoute>} />
          <Route path="/change-password" element={<ChangePassword />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </SessionProvider>
      </BrowserRouter>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
